export default class NewsletterForm {
  
  constructor(form) {
    this.form = form;
    this.widgetId = null;

    this.emailErrorText = 'Bitte geben Sie eine gültige E-Mail-Adresse ein.';
    this.sectorErrorText = 'Bitte wählen Sie ein Gewerk aus.';
    this.dataErrorText = 'Bitte bestätigen Sie die Datenschutzbestimmungen.';

    this.init();
  }

  init() {
    let that = this;
    $('.c-newsletter-form select').each(function(){
      let placeholder = $(this).attr('data-placeholder');
      $(this).selectize({
        placeholder: placeholder,
        plugins: ['remove_button'],
      });
    });

    if(window.grecaptcha) {
      window.grecaptcha.ready(function(){
        that.widgetId = window.grecaptcha.render('newsletter_recaptcha', {
          'sitekey' : ajax_args.newsletter_form_recaptcha_key,
          'size' : 'normal',
        });

        $('#newsletter_submit').on('click', function( event ) {
          event.preventDefault();
          if(that.validate()) {
            that.form.submit();
            window.grecaptcha.reset(that.widgetId);
          }
        });
      });
    }
  }

  validate() {
    let email = $('#newsletter_email');
    let sector = $('#newsletter_sector');
    let terms = $('#newsletter_accept_terms');
    let accepted_terms = document.getElementById('newsletter_accept_terms').checked;
    let captcha = $('.c-newsletter-form__recaptcha');

    const testEmail = /^[A-Z0-9._%+-]+@([A-Z0-9-]+\.)+[A-Z]{2,4}$/i;

    let valid = true;

    email.parent().children('.c-newsletter-form__field--error').remove();
    email.removeClass('o-input--error');

    sector.parent().children('.c-newsletter-form__field--error').remove();
    $('#newsletter_sector + .selectize-control').removeClass('selectize-control--error');

    captcha.removeClass('c-newsletter-form__recaptcha--error');

    if (testEmail.test(email.val()) == false) {
      let el = $('<div>').addClass('c-newsletter-form__field--error');
      el.html(this.emailErrorText);
      email.parent().append(el);
      email.addClass('o-input--text--error');
      valid = false;
    }

    if (sector.val() == null || sector.val() == '') {
      let el = $('<div>').addClass('c-newsletter-form__field--error');
      el.html(this.sectorErrorText);
      sector.parent().append(el);
      $('#newsletter_sector + .selectize-control').addClass('selectize-control--error');
      valid = false;
    }

    if (accepted_terms == false) {
      terms.addClass('o-input--checkbox--error');
      valid = false;
    }

    if(window.grecaptcha.getResponse(this.widgetId).length == 0) {
      captcha.addClass('c-newsletter-form__recaptcha--error');
      valid = false;
    }

    return valid;
  }
}



// WEBPACK FOOTER //
// ./scripts/components/newsletter-form.js